import { createFileRoute } from '@tanstack/react-router';

import { LogsPage } from '@/features/owner/LogsPage';

export const Route = createFileRoute('/_authed/owner/logs')({
  component: LogsPage,
});
